/**
 * Adds target="_blank" and rel="nofollow noopener" attributes to external links.
 */
import { $Qll, $Q } from '../utils/query-selector';

export function addAttributesToLinks() {
    const links = $Qll('a');
    const hostname = location.hostname;
    for (const link of links) {
      if (link.hostname !== hostname) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'nofollow noopener');
      }
    }
  }